import { Navigate, Route, Routes } from 'react-router-dom'
import SignIn from '../../features/auth/SignIn'
import Register from '../../features/auth/Register'
import { useAppSelector } from '../redux/store'
import MainLayout from '../../components/MainLayout'
import Home from '../../features/home/Home'
import Playlist from '../../features/playlist/Playlist'
import Library from '../../features/library/Library'
import CategoryPage from '../../features/category/CategoryPage'
import Settings from '../../features/settings/Settings'
import Orders from '../../features/orders/Orders'
import Styles from '../../features/styles/Styles'
import Bussiness from '../../features/bussiness/Bussiness'
import PlayListCollection from '../../features/playlist-collection/PlayListCollection'
import AllCategoryPlaylistsPage from '../../features/AllCategoryPlaylistsPage/AllCategoryPlaylistsPage'
import PlaylistTagPage from '../../features/PlaylistTagPage/PlaylistTagPage'
import TermsFR from '../../features/terms/fr/TermsFR'
import TermsUA from '../../features/terms/ua/TermsUA'

export default function AppRoutes() {
  const { token } = useAppSelector((state) => state.auth)

  return (
    <Routes>
      {token ? (
        <>
          <Route path="/" element={<MainLayout />}>
            <Route index element={<Navigate to="/home" replace />} />
            <Route path="home" element={<Home />} />

            <Route path="playlist/:id" element={<Playlist />} />
            <Route path="category/:type/:id" element={<CategoryPage />} />
            <Route path="library" element={<Library />} />
            <Route path="settings" element={<Settings />} />
            <Route path="orders" element={<Orders />} />

            {/* "Ещё" для любого типа */}
            <Route
              path="playlist-collection/:type"
              element={<AllCategoryPlaylistsPage />}
            />

            {/* Открытие конкретной папки/категории */}
            <Route
              path="playlist-collection/:type/:id"
              element={<PlayListCollection />}
            />

            {/* new for tags down */}
            <Route
              path="/playlist-category/:uploadedDestination/:id"
              element={<PlaylistTagPage />}
            />

            <Route path="styles" element={<Styles />} />
            <Route path="bussiness" element={<Bussiness />} />
          </Route>

          <Route path="*" element={<Navigate to="/home" replace />} />
        </>
      ) : (
        <>
          <Route path="/" element={<SignIn />} />
          <Route path="/register" element={<Register />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </>
      )}
      <Route path="/terms/fr" element={<TermsFR />} />
      <Route path="/terms/ua" element={<TermsUA />} />
    </Routes>
  )
}
